import { Avatar, Box } from "@material-ui/core";
import { Quote } from "../../../../api/Quote/Quote";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { useStyles } from "../../quoteDetail.styles";
import { TopBox } from "../../../../components/TopBox";
import { AssessmentComments } from "./AssessmentComments";
import { BotBox } from "../../../../components/BotBox";

interface Props {
  quote: Quote;
  isSolar?: boolean;
  isGraphVisible?: boolean;
}
export const AssessmentCommentsSection = ({ quote, isSolar, isGraphVisible }: Props) => {
  const classes = useStyles();
  const { isMoreThanSm, isMoreThanMd } = useBreakpoint();
  return (
    <Box bgcolor={isSolar && isGraphVisible ? "#f7f7f7" : "#fff"} mt={"97px"} position={"relative"}>
      {isSolar && isGraphVisible && (
        <TopBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
      )}
      <Box
        textAlign={"center"}
        fontSize={isMoreThanSm ? "28px" : "20px"}
        color={"#1e073f"}
        fontWeight={500}
        width={"100%"}
        position={isSolar && isGraphVisible ? "absolute" : "relative"}
        top={isSolar && isGraphVisible ? "82px" : "inherit"}
      >
        Assessment <span className={classes.colorOrange}>Comments</span>
      </Box>
      {quote.assessor?.photoUrl && (
        <Box display="flex" justifyContent="center" mb={isMoreThanMd ? 4 : 0} mt={isMoreThanMd ? 0 : 12}>
          <Avatar alt="Assessor" src={quote.assessor.photoUrl} className={classes.avatar} />
        </Box>
      )}
      <AssessmentComments quote={quote} isSolar={isSolar} isGraphVisible={isGraphVisible} />
      {isSolar && isGraphVisible && (
        <BotBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
      )}
    </Box>
  );
};
